import React from 'react';

const baseClasses =
  'flex-1 py-2.5 px-4 rounded-[10px] text-sm font-bold uppercase cursor-pointer transition-all duration-300 border-none bg-gradient-to-br from-[#fcb319] to-[#f5a500] shadow-[0_2px_4px_rgba(252,179,25,0.25)] hover:from-[#f5a500] hover:to-[#e69500] hover:-translate-y-px hover:shadow-[0_4px_12px_rgba(252,179,25,0.35)] max-md:py-2.5 max-md:px-3 max-md:text-[13px] max-md:min-h-[40px]';

const variantClasses = {
  default: 'text-[var(--text-primary)] dark:text-[#1d4746]',
  drill: 'text-[#1e3d6f]',
};

export function ContinueButton({ onClick, children = 'CONTINUE', variant = 'default' }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant] ?? variantClasses.default}`}
    >
      {children}
    </button>
  );
}
